import * as React from 'react'
// eslint-disable-next-line flowtype/require-valid-file-annotation
// @flow
import styled, { type StyledComponent } from 'styled-components'

type Props = {
  children: React.Node,
  noPaddingTop?: boolean,
  containerClassName?: string,
}

const OuterContainer: StyledComponent<'div', any, Props> = styled.div`
  height: 100%;
  overflow: auto;
  width: 100%;
  flex: 1;
`

const InnerContainer: React.ComponentType<{}> = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  ${(props: { $noPaddingTop: boolean }) =>
    props.$noPaddingTop ? '' : 'padding-top: 4rem;'}
`
type FormContainerProps = React.ElementConfig<typeof Spinner> & Props

function FormContainer({
  children,
  noPaddingTop,
  containerClassName,
  ...props
}: FormContainerProps): React.Node {
  return (
    <OuterContainer {...props}>
      <InnerContainer $noPaddingTop={noPaddingTop} className={containerClassName}>
        {children}
      </InnerContainer>
    </OuterContainer>
  )
}
export default FormContainer
